/**
 * Trunnion AI - Conditional Edge
 * Labeled conditional edge for branching paths.
 */

import { memo } from 'react';
import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  type EdgeProps,
} from '@xyflow/react';
import type { WorkflowEdgeData } from '@/types';

export const ConditionalEdge = memo(function ConditionalEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  label,
  selected,
}: EdgeProps & { data?: WorkflowEdgeData }) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  const edgeLabel = label ?? data?.condition ?? '';

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          stroke: selected ? '#FFCC33' : '#EAB308',
          strokeWidth: selected ? 3 : 2,
          strokeDasharray: '8 4',
        }}
      />
      {edgeLabel && (
        <EdgeLabelRenderer>
          <div
            className="pointer-events-all absolute rounded-md bg-trunnion-slate-800 border border-yellow-500/30 px-2 py-1 text-xs font-medium text-yellow-300 shadow-lg"
            style={{
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
            }}
          >
            {String(edgeLabel)}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
});
